import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  recidivismActions: null,
  recidivismActionsDisciplinarias: null,
  recidivismActionsLength: 0,
  recidivismActionsError: "",
};

export default function RecidivismActionsReducer(state = initialData, action) {
  switch (action.type) {
    // Cargando acciones de reincidencias
    case actions.LOADING_RECIDIVISM_ACTIONS:
      return { ...state, loading: action.payload };

    // Obtener las reincidencias
    case actions.GET_RECIDIVISM_ACTIONS:
      return {
        ...state,
        recidivismActions: action.payload.recidivismActions,
        recidivismActionsLength: action.payload.recidivismActionsLength,
      };

    // Obtener las acciones disciplinarias
    case actions.GET_RECIDIVISM_ACTIONS_DISCIPLINARIAS:
      return {
        ...state,
        recidivismActionsDisciplinarias: action.payload.recidivismActionsDisciplinarias,
      };

    // Error en las acciones de reincidencias
    case actions.RECIDIVISM_ACTIONS_FAIL:
      return { ...state, recidivismActionsError: action.payload };

    // Caso por defecto
    default:
      return state;
  }
}